require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import vClickOutside from "click-outside-vue3";
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

const appName = 'OrthoMatrix';

createInertiaApp({
	title: (title) => title ? title : appName,
	resolve: (name) => require(`./Pages/${name}.vue`),
	setup({ el, app, props, plugin }) {
		return createApp({ render: () => h(app, props) })
			.use(plugin)
			.use(vClickOutside)
			.use(ToastPlugin, {
				position: 'top-right',
				duration: 7000,
			})
			.mixin({ methods: { route } })
			.mount(el);
	},
});

InertiaProgress.init({ color: '#5AAE4B' });
